export default __webpack_public_path__ + "static/media/travel-logo.22669565.svg";